import styled from '@emotion/native'

export const MessageContainer = styled.View(({}) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
}))
